import { ShieldCheck } from "lucide-react";
import { Alert, AlertDescription } from "~/components/ui/alert";

/**
 * Standalone crisis-line notice, extracted out of `SupportFooterCta` so the
 * landing's closing CTA band can render it under the centered button pair
 * without also pulling in the two-link triage card grid. The copy and phone
 * number must stay verbatim wherever this renders.
 */
export function CrisisLineAlert() {
  return (
    <Alert className="text-left">
      <ShieldCheck className="h-4 w-4" />
      <AlertDescription className="text-[13px] leading-relaxed">
        Podrška nije zamena za hitne službe. Ako si u akutnoj krizi,
        pozovi 112 ili SOS telefon Srce na <strong>0800 300 303</strong>{" "}
        (svaki dan 14:00-23:00).
      </AlertDescription>
    </Alert>
  );
}
